import { useRouter, useSearchParams } from 'next/navigation';
import { useState } from 'react';

export default function IFrameNavbar({ bgColor }: { bgColor?: string }) {
  const searchParams = useSearchParams();

  const [searchQuery, setSearchQuery] = useState(searchParams.get('query') || '');
  const router = useRouter();

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();

    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.set('query', searchQuery);

    router.push(currentUrl.pathname + currentUrl.search);
  };

  const handleClearSearch = () => {
    setSearchQuery('');

    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.delete('query');
    router.push(currentUrl.pathname + currentUrl.search);
  };
  return (
    <nav className='flex-1 p-4 z-30' style={{ backgroundColor: bgColor }}>
      <form onSubmit={handleSearch} className='flex items-center gap-1'>
        <div className='search-full-width flex relative items-center rounded-[25px] w-full bg-white'>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='24'
            height='24'
            fill='none'
            stroke='currentColor'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
            className='w-5 h-5 ml-3'
            viewBox='0 0 24 24'
          >
            <circle cx='11' cy='11' r='8' />
            <line x1='21' y1='21' x2='16.65' y2='16.65' />
          </svg>

          <input
            type='text'
            placeholder='Search...'
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className='w-full pl-2 pr-10 py-2 focus:outline-none rounded-[25px]'
          />
          {searchQuery && (
            <button
              type='button'
              onClick={handleClearSearch}
              className='absolute right-3 text-gray-400 hover:text-white'
            >
              <svg
                xmlns='http://www.w3.org/2000/svg'
                fill='none'
                viewBox='0 0 24 24'
                strokeWidth={2}
                stroke='currentColor'
                className='w-5 h-5'
              >
                <path strokeLinecap='round' strokeLinejoin='round' d='M6 18L18 6M6 6l12 12' />
              </svg>
            </button>
          )}
        </div>
      </form>
    </nav>
  );
}
